import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Check } from './Icons';

function Checkbox({
  options = [],
  name,
  selectedValues = [],
  onChange,
  disabled = false,
  error = false,
  errorMessage = 'This field is required',
  checkedColor,
  checkColor,
  className,
  checkBoxClass,
  labelClass,
}) {
  const handleChange = (e) => {
    const { value } = e.target;
    let updatedValues = [...selectedValues];

    if (e.target.checked) {
      updatedValues.push(value);
    } else {
      updatedValues = updatedValues.filter((val) => val !== value);
    }

    onChange(updatedValues);
  };

  return (
    <div>
      <div className="flex flex-wrap gap-4">
        {options.map((option) => {
          const isChecked = selectedValues.includes(option.value);

          return (
            <label
              key={option.value}
              htmlFor={`${name}-${option.value}`}
              className={clsx(
                className,
                'flex items-center gap-2 cursor-pointer py-2',
                disabled && 'opacity-50 cursor-not-allowed'
              )}
            >
              <input
                type="checkbox"
                name={name}
                id={`${name}-${option.value}`}
                value={option.value}
                checked={isChecked}
                onChange={handleChange}
                disabled={disabled}
                className="sr-only"
              />

              <div
                className={clsx(
                  'flex items-center justify-center border rounded w-4 h-4 flex-shrink-0',
                  checkBoxClass,
                  isChecked
                    ? checkedColor
                      ? `${checkedColor} border-${checkedColor.replace('bg-', '')}`
                      : 'bg-indigo-600 border-indigo-600'
                    : 'border-gray-300 bg-white'
                )}
              >
                {isChecked && (
                  <Check className={clsx(checkColor ? checkColor : 'text-white', 'w-3 h-3')} />
                )}
              </div>

              <span
                className={
                  labelClass ? labelClass : 'font-medium text-xs 2xl:text-base text-[#344054]'
                }
              >
                {option.label}
              </span>
            </label>
          );
        })}
      </div>

      {error && <p className="text-red-600 text-xs mt-1">{errorMessage}</p>}
    </div>
  );
}

Checkbox.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  name: PropTypes.string.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  checkedColor: PropTypes.string,
  checkColor: PropTypes.string,
  className: PropTypes.string,
  checkBoxClass: PropTypes.string,
};

export default Checkbox;
